import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SettingsSection } from "./settingSection.component";
import { ToggleWithLabel } from "web-apps/company/components/general/toggle/toggleWithLabelProps.component";

export const AutoAcceptAllGigsSetting: React.FC<{
  value: boolean;
  onChange: (v: boolean) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const [touched, setTouched] = useState(false);
  const showError = touched && value === undefined;

  const handleToggle = (next: boolean) => {
    setTouched(true);
    onChange(next);
  };

  return (
    <SettingsSection
      title={t("System.AutoAcceptAllGigs")}
      info={t("System.AutoAcceptAllGigsInfo")}
    >
      <ToggleWithLabel
        label={t("System.AutoAcceptAllGigs")}
        leftLabel={t("System.Off")}
        rightLabel={t("System.On")}
        value={value}
        onChange={handleToggle}
        required
        hasError={showError}
        errorText={showError ? t("System.Required") : undefined}
      />
    </SettingsSection>
  );
};
